// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2128":"5646acd3","3985":"7c5b3e12","6082":"5646acd3"}[chunkId] + ".chunk.css";
};